import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import axios from 'axios';

import getMetaTagData from '../../../src/common/services/getMetaTagData';
import TvTopMenu from '../../../src/component/m/tv/TopMenu';
import Theme from '../../../src/component/m/tv/Theme';
import Box from '../../../src/component/m/common/Box';
import Loading from '../../../src/component/m/common/Loading';

import { getSectionDataApiUrl } from '../../../src/common/utils/tvUtil';
import { SECTION_LIST_PAGE_LIMIT } from '../../../src/common/constants/number';
import { toFit } from '../../../src/hooks/useToFit';

function Home({ defaultMetaTagData }) {
  const [sortHTxt, setSortHTxt] = useState('');
  const router = useRouter();
  const { pageSection: section, category = '', sort = 'top' } = router.query; // 기본값 'top' 설정

  const [pageSection, setPageSection] = useState(section);
  const [metaTagData, setMetaTagData] = useState(defaultMetaTagData);
  const [pageQueryParams, setPageQueryParams] = useState({
    section,
    category,
    sort,
    offset: 0,
    limit: SECTION_LIST_PAGE_LIMIT,
  });
  const [sectionDataList, setSectionDataList] = useState([]);
  const [sectionDataIsLoading, setSectionDataIsLoading] = useState(false);

  // useEffect(() => {
  //   // 컴포넌트가 마운트될 때 `sectionDataList.length` 값을 alert으로 보여줍니다.
  //   alert(`현재 sectionDataList의 길이: ${sectionDataList.length}`);
  // }, [sectionDataList]); // sectionDataList가 변경될 때마다 실행됩니다.

  function sortCodeTxt(code) {
    let result;
    try {
      if (code === 'new') {
        result = '최신';
      } else if (code === 'top') {
        result = '인기';
      } else if (code === 'abc') {
        result = '가나다';
      } else if (code === 'theme') {
        result = '추천';
      } else if (code === 'all') {
        result = '전체';
      } else if (code === 'N') {
        result = '방영 예정';
      } else if (code === 'Y') {
        result = '방영 중';
      } else {
        result = '';
      }
    } catch (error) {
      result = '';
    }

    return result;
  }

  function onPageQueryParamsChanged({
    sectinoCode = '',
    categoryCode = '',
    sortCode = '',
  }) {
    setSortHTxt(sortCodeTxt(sortCode));
    pageQueryParams.section = sectinoCode;
    pageQueryParams.category = categoryCode;
    pageQueryParams.sort = sortCode;
    pageQueryParams.offset = 0;

    setPageQueryParams({ ...pageQueryParams });
    setPageSection(sectinoCode);
  }

  useEffect(() => {
    if (!router.query.sort) {
      router.replace({
        pathname: router.pathname,
        query: { ...router.query, sort: 'top' },
      });
    }
  }, [router.query]);

  useEffect(() => {
    window.document.addEventListener('scroll', toFit(doNextPage, {}));

    function doNextPage() {
      if (
        window.innerHeight + Math.ceil(window.pageYOffset) >=
        document.body.offsetHeight
      ) {
        setPageQueryParams((prev) => {
          const nextOffset = prev.offset + prev.limit;
          let sectionDataListLength;
          setSectionDataList((sPrev) => {
            sectionDataListLength = sPrev.length;
            return sPrev;
          });

          if (sectionDataListLength === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    const sectionDataApiUrl = getSectionDataApiUrl(
      pageQueryParams.offset,
      pageQueryParams.sort,
      pageQueryParams.section,
      pageQueryParams.category
    );
    const config = {
      method: 'get',
      url: sectionDataApiUrl.href,
      timeout: 3000,
    };

    setSectionDataIsLoading(true);

    axios(config)
      .then(function (response) {
        const addList = [];
        let clickParamsCategory = pageQueryParams.category;
        if (clickParamsCategory === null || clickParamsCategory === '') {
          clickParamsCategory = 'total';
        }
        const clickParamsSort = pageQueryParams.sort;
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          const item = {
            type: 'poster',
            img: element.pgm_img_url,
            info: { title: element.pgm_nm },
            label: [],
            link: element.link_url,
            isNew: element.new_yn === 'Y',
            contents: element.contents,
            data: { pgm_nm: element.pgm_nm },
            isfree: element.free_part_yn,
            link_new_yn: element.link_new_yn,
            clickParams:
              'div=tv_' + clickParamsCategory + '_' + clickParamsSort,
          };
          addList.push(item);
        }

        const currentOffset =
          Number.parseInt(sectionDataApiUrl.searchParams.get('offset')) || 0;

        if (currentOffset === 0) {
          if (addList.length > 0) {
            setSectionDataList(addList);
          } else {
            setSectionDataList([]);
          }
        } else {
          setSectionDataList((prev) => [...prev, ...addList]);
        }
      })
      .catch(function (error) {
        //console.log(error);
      })
      .finally(() => {
        setSectionDataIsLoading(false);
      });
  }, [pageQueryParams]);

  if (pageQueryParams.sort === 'theme') {
    return (
      // TODO: `contents` css class를 빼는것이 맞는지 확인 필요
      <div className="contents">
        {/* <div id='container'> */}
        <Head>
          <link
            rel="stylesheet"
            href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
          />
          <meta
            name="viewport"
            content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
          />
          <script
            type="text/javascript"
            src={process.env.NEXT_PUBLIC_GNB_JS_URL}
          />

          <meta name="description" content={metaTagData.shareDescription} />
          <meta name="keywords" content={metaTagData.keywords} />
          <meta name="twitter:card" content="summary" />
          <noscript>Your browser does not support JavaScript!</noscript>
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="ko_KR" />
          <meta property="og:site_name" content="SBS" />
          <meta property="og:title" content={metaTagData.shareTitle || ''} />
          <meta
            property="og:description"
            content={metaTagData.shareDescription || ''}
          />
          <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
          <meta property="og:url" content={metaTagData.currentUrl || ''} />
          <meta name="nate:site_name" content="SBS" />
          <meta name="nate:title" content={metaTagData.shareTitle || ''} />
          <meta
            name="nate:description"
            content={metaTagData.shareDescription || ''}
          />
          <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
          <meta name="nate:url" content={metaTagData.currentUrl || ''} />
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role="main" id="container" className="tv_listcontents_wrap">
          {/* 페이지 명 클래스  */}
          <TvTopMenu
            sectionCode={section}
            categoryCode={category}
            sortCode={sort}
            onChange={onPageQueryParamsChanged}
          />
          <h3 className="hide">{sortHTxt}</h3>
          <Theme />
          {/* 테마일때만 */}
          {/* {sectionDataList.filter(x => Array.isArray(x.contens) || Array.isArray(x.contents))
            .map((item, index) => {
              return (
                <SliderWithTitle
                  key={index}
                  view={relateContentIndex === index}
                  slide_key={index}
                  title={item.info.title}
                  desc={item.desc || item.info.title}
                  link={item.link || ''}
                  type='poster'// TODO  임시 티비쪽은 포스터로 무조건 쓰는지 확인해야함 아니면 api 에서 자료 요청해야함
                  data={item.contens || item.contents}
                  relate_id={item.relate_id}
                  relate_title={item.relate_title}
                  relate_title_view_yn={item.relate_title_view_yn}
                  relate_type={item.relate_type}
                  bottom_type={item.bottom_type}
                />
              );
            })} */}

          {/* {sectionDataIsLoading && <Loading />} */}
        </div>

        {/* <BtnTop /> */}
      </div>
    );
  } else {
    return (
      // TODO: `contents` css class를 빼는것이 맞는지 확인 필요
      <div className="contents">
        {/* <div id='container'> */}
        <Head>
          <link
            rel="stylesheet"
            href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
          />
          <meta
            name="viewport"
            content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
          />
          <script
            type="text/javascript"
            src={process.env.NEXT_PUBLIC_GNB_JS_URL}
          />

          <meta name="description" content={metaTagData.shareDescription} />
          <meta name="keywords" content={metaTagData.keywords} />
          <meta name="twitter:card" content="summary" />
          <noscript>Your browser does not support JavaScript!</noscript>
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="ko_KR" />
          <meta property="og:site_name" content="SBS" />
          <meta property="og:title" content={metaTagData.shareTitle || ''} />
          <meta
            property="og:description"
            content={metaTagData.shareDescription || ''}
          />
          <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
          <meta property="og:url" content={metaTagData.currentUrl || ''} />
          <meta name="nate:site_name" content="SBS" />
          <meta name="nate:title" content={metaTagData.shareTitle || ''} />
          <meta
            name="nate:description"
            content={metaTagData.shareDescription || ''}
          />
          <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
          <meta name="nate:url" content={metaTagData.currentUrl || ''} />
          <title>{metaTagData.shareTitle}</title>
          <title>{metaTagData.shareTitle}</title>
        </Head>
        <div role="main" id="container" className="tv_listcontents_wrap">
          {/* 페이지 명 클래스  */}
          <TvTopMenu
            sectionCode={section}
            categoryCode={category}
            sortCode={sort}
            onChange={onPageQueryParamsChanged}
          />

          {/* 기본 정렬 */}
          <div className="contents_area_tvlist">
            <div className="tv_list_w">
              {/* <!-- sorgint_btn_cont 에 current 된 탭 이름 타이틀로 제공 --> */}
              <h3 className="hide">{sortHTxt}</h3>
              <ul className="tv_list_inner">
                {sectionDataList.slice(0, 6).map((item, index) => {
                  return (
                    <li key={index} className="tv_list_cont">
                      <Box view {...item} />
                    </li>
                  );
                })}
              </ul>
              <div className="contents_middle_ad">
                <div className="middle_ad_inner">
                  <iframe
                    title="배너광고"
                    display="block"
                    src="/html/m/tv_right.htm"
                    width="320px"
                    height="100px"
                    scrolling="no"
                    frameBorder="0"
                    align="middle"
                    marginWidth="0"
                    marginHeight="0"
                  />
                </div>
              </div>
              <ul className="tv_list_inner">
                {sectionDataList.slice(6).map((item, index) => {
                  return (
                    <li key={index} className="tv_list_cont">
                      <Box view {...item} />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {sectionDataIsLoading && <Loading />}
        </div>
      </div>
    );
  }
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const defaultMetaTagData = getMetaTagData(
    ctx.req.url,
    pageSection,
    pageCategory
  );

  const tvSectionTopList = await getTvSectionTopList(pageSection, pageCategory);

  if (
    Array.isArray(tvSectionTopList?.data) &&
    tvSectionTopList.data.length > 0
  ) {
    const topProgramTitleList = tvSectionTopList.data.map(
      (item) => item.pgm_nm
    );
    if (defaultMetaTagData.keywords) {
      defaultMetaTagData.keywords =
        defaultMetaTagData.keywords + ',' + topProgramTitleList.toString();
    } else {
      defaultMetaTagData.keywords = topProgramTitleList.toString();
    }
  }

  return { props: { defaultMetaTagData } };
}

async function getTvSectionTopList(sectionCode, categoryCode) {
  const sectionDataApiUrl = getSectionDataApiUrl(
    0,
    'top',
    sectionCode,
    categoryCode,
    20
  );
  const config = {
    method: 'get',
    url: sectionDataApiUrl.href,
    timeout: 3000,
  };

  return axios(config).catch(function (error) {
    //console.log(error);
  });
}

export default Home;
